import React from 'react';

// eslint-disable-next-line react/display-name
export const DropdownItemsContainer = React.forwardRef((props: { children: React.ReactNode }, ref) => {
  // @ts-ignore
  return <ul ref={ref}>{props.children}</ul>;
});
